<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      {{ $auth.user().name }}
    </template>
  </AppHeaderDropdown>
</template>
<style>
.app-header .nav-link {
  margin-right: 30px;
  padding-left: 15px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import router from '@/router'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout() {
      this.$auth.logout()
      router.push({ name: 'login' })
    }
  }
}
</script>
